import { Box, Modal, Grid, Zoom, Checkbox, FormControlLabel, RadioGroup, Stack } from '@mui/material';
import { BackdropLoading } from '../../../shared/spinner/backdropLoading';
import { CancelButton, CheckBoxContainer, ModalLabel, modalStyle, OkButton, OperatorRadio } from './gyoshuCondition.styles';
import React, { useRef } from 'react';
import { sessionDisconnectedCheck } from '../../../shared/api/sessionDisconnectedCheck';
import { fetchAuthSession } from 'aws-amplify/auth';
import { SearchCrudApiRequest } from '../../../shared/model/apiRequestModel';
import crud from '../../../shared/api/crud';
import { SystemErrorMsg, SystemErrorTitle } from '../../../constants';
import { useNavigate } from 'react-router-dom';
import { ChubunruiListContainer, SaibunruiListContainer, ShobunruiListContainer } from './checkBoxCompornent';

interface OwnProps {
    isOpen: boolean,
    handleClose: (isOpen: boolean) => void
    handleOk: (value: DialogItemType[], operator: string) => void,
}

interface DialogItemType {
    id: string
    value: string
}

interface ChubunruiInfo {
    GYSHCD: string
    GYSHMKNJ1: string
}

interface ShobunruiInfo {
    GYSHCD: string
    GYSHMKNJ1: string
}

interface SaibunruiInfo {
    GYSHCD: string
    GYSHMKNJ1: string
}

interface Checkcode {
    chuBunrui: Set<string>
    shoBunrui: Set<string>
    saiBunrui: Set<string>
}

const screenId = "U045"

const GyoshuDialog = (props: OwnProps) => {
    const navigate = useNavigate();
    const { isOpen, handleClose } = props
    const [open, setOpen] = React.useState(isOpen);
    const [operator, setOperator] = React.useState('or');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState(false)
    const idRef = useRef(0);

    const [chubunruiList, setChubunruiList] = React.useState<ChubunruiInfo[]>([]);
    const [shobunruiList, setShobunruiList] = React.useState<ShobunruiInfo[]>([]);
    const [saibunruiList, setSaibunruiList] = React.useState<SaibunruiInfo[]>([]);

    //チェック状態管理
    const [checkCode, setCheckCode] = React.useState<Checkcode>({ chuBunrui: new Set(), shoBunrui: new Set(), saiBunrui: new Set() });

    //中分類取得
    const getGyoshuChubunrui = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "getGyoshuMaster", navigate)) {
            return
        }
        setLoading(true)
        const session = await fetchAuthSession();
        const email = session.tokens?.idToken?.payload?.email?.toString() || '';
        const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
        const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
        const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
        const contractForm = contract.length !== 0 && contract[0].contractForm;
        const request: SearchCrudApiRequest = {
            sessionId: sessionId,
            userMailAddress: email,
            processFlag: "0",
            countFlag: "0",
            contractForm: contractForm,
            targetTableName: 'M_GYOSHU',
            selectItems: ['GYSHCD', 'GYSHMKNJ1', "GT_CBNR_GYSHCD"],
            conditions: [
                {
                    targetColumn: "GYSHBNRSKBTCD",
                    targetValue: ['2']
                }
            ],
            conditionsOperator: 'and',
            orderBy: [
                {
                    sortColumn: 'GYSHCD',
                    sortRule: 'ASC',
                }
            ],
            usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
        }

        const response = crud(request);
        const resCd = (await response).resCd;
        if (resCd === 'I0000') {
            const chubunruiList: ChubunruiInfo[] = (await response).data?.resultData.map((item: { GYSHCD: string; GYSHMKNJ1: string; }) => {
                return { GYSHCD: item.GYSHCD, GYSHMKNJ1: item.GYSHMKNJ1 }

            });
            setLoading(false);
            setChubunruiList(chubunruiList);
        } else {
            setLoading(false);
            navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        };
    };

    //小分類取得
    const getGyoshuShobunrui = async (GYSHCD: string, currentId: number) => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "getGyoshuMaster", navigate)) {
            return
        }
        setLoading(true)
        const session = await fetchAuthSession();
        const email = session.tokens?.idToken?.payload?.email?.toString() || '';
        const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
        const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
        const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
        const contractForm = contract.length !== 0 && contract[0].contractForm;
        const request: SearchCrudApiRequest = {
            sessionId: sessionId,
            userMailAddress: email,
            processFlag: "0",
            countFlag: "0",
            contractForm: contractForm,
            targetTableName: 'M_GYOSHU',
            selectItems: ['GYSHCD', 'GYSHMKNJ1'],
            conditions: [
                {
                    targetColumn: "GYSHBNRSKBTCD",
                    targetValue: ['3']
                },
                {
                    targetColumn: "GT_CBNR_GYSHCD",
                    targetValue: [GYSHCD]
                }
            ],
            conditionsOperator: 'and',
            orderBy: [
                {
                    sortColumn: 'GYSHCD',
                    sortRule: 'ASC',
                }
            ],
            usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
        }

        const response = crud(request);
        const resCd = (await response).resCd;
        if (resCd === 'I0000') {
            const shobunruiList: ShobunruiInfo[] = (await response).data?.resultData.map((item: { GYSHCD: string; GYSHMKNJ1: string; }) => {
                return { GYSHCD: item.GYSHCD, GYSHMKNJ1: item.GYSHMKNJ1, }

            });
            setLoading(false);
            if (currentId !== idRef.current) return;
            setShobunruiList(shobunruiList)
        } else {
            setLoading(false);
            navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        };
    };

    //細分類取得
    const getGyoshuSaibunrui = async (GYSHCD: string, currentId: number) => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "getGyoshuMaster", navigate)) {
            return
        }
        setLoading(true)
        const session = await fetchAuthSession();
        const email = session.tokens?.idToken?.payload?.email?.toString() || '';
        const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
        const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
        const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
        const contractForm = contract.length !== 0 && contract[0].contractForm;
        const request: SearchCrudApiRequest = {
            sessionId: sessionId,
            userMailAddress: email,
            processFlag: "0",
            countFlag: "0",
            contractForm: contractForm,
            targetTableName: 'M_GYOSHU',
            selectItems: ['GYSHCD', 'GYSHMKNJ1'],
            conditions: [
                {
                    targetColumn: "GYSHBNRSKBTCD",
                    targetValue: ['4']
                },
                {
                    targetColumn: "GT_SHBNR_GYSHCD",
                    targetValue: [GYSHCD]
                }
            ],
            conditionsOperator: 'and',
            orderBy: [
                {
                    sortColumn: 'GYSHCD',
                    sortRule: 'ASC',
                }
            ],
            usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
        }

        const response = crud(request);
        const resCd = (await response).resCd;
        if (resCd === 'I0000') {
            const saibunruiList: SaibunruiInfo[] = (await response).data?.resultData.map((item: { GYSHCD: string; GYSHMKNJ1: string; }) => {
                return { GYSHCD: item.GYSHCD, GYSHMKNJ1: item.GYSHMKNJ1, }

            });
            setLoading(false);
            if (currentId !== idRef.current) return;
            setSaibunruiList(saibunruiList)
        } else {
            setLoading(false);
            navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        };
    };

    const toggleChubunrui = (GYSHCD: string) => {
        setCheckCode((prev) => {
            const next = new Set(prev.chuBunrui);
            if (next.has(GYSHCD)) next.delete(GYSHCD);
            else next.add(GYSHCD);
            return { ...prev, chuBunrui: next };
        });
    };

    const toggleShobunrui = (GYSHCD: string) => {
        setCheckCode((prev) => {
            const next = new Set(prev.shoBunrui);
            if (next.has(GYSHCD)) next.delete(GYSHCD);
            else next.add(GYSHCD);
            return { ...prev, shoBunrui: next };
        });
    };

    const toggleSaibunrui = (GYSHCD: string) => {
        setCheckCode((prev) => {
            const next = new Set(prev.saiBunrui);
            if (next.has(GYSHCD)) next.delete(GYSHCD);
            else next.add(GYSHCD);
            return { ...prev, saiBunrui: next };
        });
    };
    //中分類でチェックされたアイテム
    const checkedChubunrui = React.useMemo(() => {
        return chubunruiList.filter((x) => checkCode.chuBunrui.has(x.GYSHCD))
    }, [checkCode.chuBunrui]);

    //小分類表示条件
    React.useEffect(() => {
        const currentId = ++idRef.current;
        if (checkedChubunrui.length !== 1) {
            setCheckCode({ ...checkCode, shoBunrui: new Set() })
            setShobunruiList([])
        } else {
            // チェックが1つだけの場合は小分類を取得する
            getGyoshuShobunrui(checkedChubunrui[0].GYSHCD, currentId)
        }
    }, [checkedChubunrui]);

    //小分類でチェックされたアイテム
    const checkedShobunrui = React.useMemo(() => {
        return shobunruiList.filter((x) => checkCode.shoBunrui.has(x.GYSHCD))
    }, [checkCode.shoBunrui]);

    //細分類表示条件
    React.useEffect(() => {
        const currentId = ++idRef.current;
        if (checkedShobunrui.length !== 1) {
            setCheckCode({ ...checkCode, saiBunrui: new Set() })
            setSaibunruiList([])
        } else {
            // チェックが1つだけの場合は細分類を取得する
            getGyoshuSaibunrui(checkedShobunrui[0].GYSHCD, currentId)
        }
    }, [checkedShobunrui]);

    React.useEffect(() => {
        if (isOpen) {
            setError(false);
            setOperator('or');
            setCheckCode({ chuBunrui: new Set(), shoBunrui: new Set(), saiBunrui: new Set() });
            if (chubunruiList.length === 0) {
                getGyoshuChubunrui()
            }
        }
        setOpen(isOpen)
    }, [isOpen])

    //ボタン押下処理
    const handleOk = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "gyoshuHandleOk", navigate)) {
            return
        }

        const chubunruiSelectItems: DialogItemType[] = [];
        const shobunruiSelectItems: DialogItemType[] = [];
        const saibunruiSelectItems: DialogItemType[] = [];

        for (const x of chubunruiList) if (checkCode.chuBunrui.has(x.GYSHCD)) chubunruiSelectItems.push({ id: x.GYSHCD, value: x.GYSHMKNJ1 });
        for (const x of shobunruiList) if (checkCode.shoBunrui.has(x.GYSHCD)) shobunruiSelectItems.push({ id: x.GYSHCD, value: x.GYSHMKNJ1 });
        for (const x of saibunruiList) if (checkCode.saiBunrui.has(x.GYSHCD)) saibunruiSelectItems.push({ id: x.GYSHCD, value: x.GYSHMKNJ1 });

        if (chubunruiSelectItems.length === 0 && shobunruiSelectItems.length === 0 && saibunruiSelectItems.length === 0) {
            setError(true);
        } else if (shobunruiSelectItems.length === 0 && saibunruiSelectItems.length === 0) {
            props.handleOk(chubunruiSelectItems, operator)
        } else if (saibunruiSelectItems.length === 0) {
            props.handleOk(shobunruiSelectItems, operator)
        } else {
            props.handleOk(saibunruiSelectItems, operator)
        }
    }

    return (
        <>
            <BackdropLoading open={loading} />
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                sx={{
                    zIndex: 900
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            zIndex: 900
                        }
                    }
                }}
            >
                <Zoom
                    in={open}
                    style={{ zIndex: 1000, transformOrigin: '-50% -50% -50%' }}
                    easing={{
                        enter: "cubic-bezier(0, 1.45, 0.62, 1)",
                        exit: "linear"
                    }}
                >
                    <Box sx={modalStyle} tabIndex={-1}>
                        <ModalLabel>
                            選択条件 - 業種
                        </ModalLabel>
                        <Stack direction={"row"} marginTop={1} >
                            <Box marginLeft={3} alignContent='center'>
                                <RadioGroup row value={operator} onChange={e => setOperator(e.target.value)} >
                                    <FormControlLabel value="and" control={<OperatorRadio />} label="AND" />
                                    <FormControlLabel value="or" control={<OperatorRadio />} label="OR" />
                                </RadioGroup>
                            </Box>
                            {
                                error ?
                                    <Box alignContent='center' marginLeft={3} sx={{ color: 'red', fontSize: '1.2rem' }}>   条件を一つ以上選択してください</Box>
                                    :
                                    <></>
                            }
                        </Stack>
                        <Box p={1} marginBottom={1}>
                            <Grid container justifyContent="center" columnGap={1}>
                                <Grid container size={3.9}>
                                    <ChubunruiListContainer chubunruiList={chubunruiList} checkCode={checkCode.chuBunrui} toggleChubunrui={toggleChubunrui}>
                                    </ChubunruiListContainer>
                                </Grid>
                                <Grid container size={3.9}>
                                    <ShobunruiListContainer shobunruiList={shobunruiList} checkCode={checkCode.shoBunrui} toggleShobunrui={toggleShobunrui}>
                                    </ShobunruiListContainer>
                                </Grid>
                                <Grid container size={3.9}>
                                    <SaibunruiListContainer saibunruiList={saibunruiList} checkCode={checkCode.saiBunrui} toggleSaibunrui={toggleSaibunrui}>
                                    </SaibunruiListContainer>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box p={2} sx={{ marginTop: '-2%', marginBottom: '1%' }}>
                            <Grid container sx={{ width: '98%' }}>
                                <Grid size={7} />
                                <Grid size={5}>
                                    <CancelButton variant="contained" onClick={() => handleClose(false)}>キャンセル</CancelButton>
                                    <OkButton variant="contained" onClick={() => handleOk()}>OK</OkButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Zoom>
            </Modal >
        </>
    );
}

export default GyoshuDialog;
